import { Component } from '@theme/component';

/** Keep education attached to the selected variant, including unavailable combinations. */
class KunnieProductKnowledge extends Component {
  #controller;
  #serial = 0;
  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    document.addEventListener('shopify:product:select', async (event) => {
      if (String(event.product?.id).split('/').pop() !== this.dataset.product || event.target.closest?.('product-card, quick-add-dialog')) return;
      const serial = ++this.#serial;
      // Do not display another formula while the selected variant is loading.
      this.hidden = true;
      try {
        const result = await event.promise;
        if (!this.isConnected || serial !== this.#serial) return;
        const fresh = result?.detail?.html?.querySelector(`kunnie-product-knowledge[data-product="${this.dataset.product}"]`);
        if (!fresh || !result.variant) return;
        this.replaceChildren(...fresh.childNodes);
        this.dataset.variant = fresh.dataset.variant;
        this.hidden = fresh.hidden;
      } catch { /* Remain hidden if the native picker request fails. */ }
    }, { signal: this.#controller.signal });
  }
  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }
}
if (!customElements.get('kunnie-product-knowledge')) customElements.define('kunnie-product-knowledge', KunnieProductKnowledge);
